module.exports = __webpack_public_path__ + "img/bustier.c2535207.jpg";